module.exports = __webpack_public_path__ + "media/site_templates/www.hirelocalplumbers.com.au/images/review_2-362a99f1c612b11ffe5637c22eeabcb7.png";